import * as React from "react";
import TomatoCard from "./TomatoCard";
export default function MProductsCard(props) {
    return React.createElement(TomatoCard, Object.assign({}, props));
}
